export default __webpack_public_path__ + "imgs/toForever01.e361f79.jpeg";